<template>
  <v-app>
    <v-content>

      <div class="row" style="height: 100%; margin: 0 !important;">
        <div class="column" style="background-color:#2196F3;">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <img src="../assets/img/logo.svg" height="95" width="270">
            </v-layout>
          </v-container>
        </div>
        <div class="column" style="background-color:#fff;">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-card class="elevation-0" width="600">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5">
                      Enterprise Dashboard
                    </v-list-item-title>
                    <v-list-item-subtitle>Reset password</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                  <v-card v-if="!passwordChanged && !tokenRequired" class="elevation-0">
                    <v-form @submit.prevent="setNewPassword" ref="forgotPasswordForm">
                      <v-card-text>
                        <v-alert :value="!!error" type="error">{{ error }}</v-alert>
                        <v-text-field :disabled="inProgress" v-model="password" label="New Password" type="password" :rules="[v => v.length > 7 || 'New password length should be at least 8 characters']"></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn type="submit" tile depressed color="blue white--text" :loading="inProgress" :disabled="password.length < 8">Reset password</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                  <v-card v-if="tokenRequired" class="elevation-0 px-4 py-4">
                    <v-form ref="login2FAForm">
                      <v-text-field v-model="verToken" label="Verification token from SMS" type="text" ref="verToken" :rules="[v => !!v || 'Please enter a token']"></v-text-field>
                      <v-card-actions class="pa-0">
                        <v-spacer></v-spacer>
                        <v-btn type="submit" depressed tile color="blue white--text" :loading="inProgress" :disabled="!verToken" @click.prevent="signInToken">Verify</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                  <v-card v-if="passwordChanged" class="elevation-0">
                    <v-card-text>
                      Password changed. Go to <router-link :to="{ name: 'Login' }">login form</router-link>.
                    </v-card-text>
                  </v-card>
              </v-card>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import { CHANGE_PASSWORD_BY_TOKEN, VERIFY_2FA_TOKEN } from '@/store/actions.type'

export default {
  name: 'reset-password',
  data() {
    return {
      token: '',
      userId: '',
      password: '',
      inProgress: false,
      error: '',
      passwordChanged: false,
      tokenRequired: false,
      verToken: '',
    };
  },
  methods: {
    async setNewPassword() {
      if (this.$refs.forgotPasswordForm.validate()) {
        this.inProgress = true;
        this.error = '';
        try {
          await this.$store.dispatch(CHANGE_PASSWORD_BY_TOKEN, { userId: this.userId, password: this.password, token: this.token });
          this.passwordChanged = true;
          this.inProgress = false;
        } catch(error) {
          console.log(error)
          if (error && error.status === 499) {
            this.tokenRequired = true;
            this.inProgress = false;
          } else {
            this.error = 'Something went wrong. Please contact support@planetverify.com';
            this.inProgress = false;
          }
        }
      }
    },
    async signInToken() {
      const email = this.userId;
      const token = this.verToken;
      this.showError = false;
      this.error = '';

      if (this.$refs.login2FAForm.validate()) {
        this.inProgress = true;
        // try {
          await this.$store.dispatch(VERIFY_2FA_TOKEN, { user: email, token: token });
          this.$router.push({ name: 'Data Requests' });
        // } catch (err) {
          this.error = 'Invalid token';
          this.inProgress = false;
        // }
      }
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    this.userId = this.$route.query.id;
    // if (!this.token || !this.userId) {
    //   this.$router.push({ name: 'Login' });
    // }
  },
};
</script>

<style>
.login-link {
  text-decoration: none;
}

.login-link:hover {
  text-decoration: underline;
}

.column {
  float: left;
  width: 50%;
  padding: 10px;
  min-height: 100%;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>
